<template>
  <div class="sureOrder common_content">
    <el-card class="box-card">
      <div v-if="tbodyShow">
        <ul class="tbody">
          <li class="tbody_con">
            <div class="order_detail">
              <div class="detail_con">
                <el-image
                    :src="imgPath + tbody.file_path"
                    style="width:100px;height:100px; margin-right:10px;"
                ></el-image>
                <ul style="width:76%;">
                  <li>
                    <label>测试班名称：</label>
                    <span>{{ tbody.test_class_title }}</span>
                  </li>
                  <li>
                    <label>机构名称：</label>
                    <span>{{ tbody.mechanism_fullName }}</span>
                  </li>
                  <li>
                    <label>测试地址：</label>
                    <span>{{ tbody.province + tbody.city + tbody.district + tbody.test_detail_addr }}</span>
                  </li>
                  <li>
                    <label>测试等级：</label>
                    <span>{{ tbody.grade|grade }}</span>
                  </li>
                  <li>
                    <label>测试时间：</label>
                    <span>
                      {{
                        tbody.test_start_time|dateformat('YYYY-MM-DD HH:mm:ss')
                      }} 至 {{ tbody.test_end_time|dateformat('YYYY-MM-DD HH:mm:ss') }}
                    </span>
                  </li>
                  <li>
                    <label>联系人：</label>
                    <span>{{ tbody.contact }}</span>
                  </li>
                  <li>
                    <label>电话：</label>
                    <span>{{ tbody.contact_number }}</span>
                  </li>
                </ul>
              </div>
              <div class="money">
                <h4 style="margin-bottom:5px;">金额:¥{{ tbody.registration_fee }}</h4>
              </div>
              <div class="operate" style="text-align: center;padding-top: 26px;">
                <h4 style="margin-bottom:5px;">实付:¥{{ tbody.registration_fee }}</h4>
              </div>
            </div>
          </li>
        </ul>
        <ul class="tbody">
          <li class="tbody_con">
            <div class="order">
              <span>培训信息：</span>
            </div>
            <el-form ref="coachForm" :model="coachForm" :rules="rules">
              <el-form-item prop="status" label-width="30px">
                <el-radio-group v-model="coachForm.status" @change="changeStatus">
                  <el-radio :label="0">本机构在训学员</el-radio>
                  <el-radio :label="1">非本机构在训学员</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="培训机构" prop="train" label-width="110px">
                <el-input v-model="coachForm.train" placeholder="必填，如没有请填无" style="width: 30%"
                          :disabled="coachForm.status==0"></el-input>
              </el-form-item>
              <el-form-item label="教练员姓名" prop="coach" label-width="110px">
                <el-input v-model="coachForm.coach" placeholder="必填，如没有请填无" style="width: 30%"></el-input>
              </el-form-item>
              <el-form-item label="教练员手机号" prop="phone" required label-width="110px">
                <el-input v-model="coachForm.phone" placeholder="必填，如没有请填无" style="width: 30%"></el-input>
              </el-form-item>
            </el-form>
          </li>
        </ul>
        <ul class="tbody">
          <li class="tbody_con">
            <div class="order">
              <span>发票信息：</span>
            </div>
            <div style="padding: 15px 10px;font-size: 15px;">
              <span style="padding:0px 10px;color:#ea0000">{{ radio == '1' ? '个人' : '企业' }}</span>
              <!-- <span style="padding:0px 10px;" v-if="radio=='2'">购方名称：{{formInvoice.custname}}</span>
              <span style="padding:0px 10px;" v-if="radio=='2'">购方税号：{{formInvoice.custTaxNo}}</span>-->
              <span class="upData" @click="InvoiceVisible = true">修改</span>
            </div>
            <div class="invoiceDetail" style="padding:0 15px;font-size:15px;line-height:26px">
              <ul>
                <li v-for="(item,index) in comonInvoice" :key="index">
                  <span>{{ item.title }}</span>
                  <span>{{ item.value }}</span>
                </li>
              </ul>
              <ul v-if="radio=='2'">
                <li>
                  <span>单位名称：</span>
                  <span>{{ formInvoice.custname }}</span>
                </li>
                <li>
                  <span>纳税人识别号：</span>
                  <span>{{ formInvoice.custTaxNo }}</span>
                </li>
                <li>
                  <span>注册地址：</span>
                  <span>{{ formInvoice.custAddr }}</span>
                </li>
                <li>
                  <span>注册电话：</span>
                  <span>{{ formInvoice.custPhone }}</span>
                </li>
                <li>
                  <span>开户银行：</span>
                  <span>{{ formInvoice.custBank }}</span>
                </li>
                <li>
                  <span>银行账号：</span>
                  <span>{{ formInvoice.custAccount }}</span>
                </li>
                <li>
                  <span>备注：</span>
                  <span>{{ formInvoice.invoMemo }}</span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      <no-data v-else/>
      <makeOutInvoice
          :dialogVisible="InvoiceVisible"
          ref="invoice"
          @default="defaultData"
          @cancel="cancelData"
      />
    </el-card>
    <el-card class="box-card signUp_card">
      <span>合计：</span>
      <span style="color:#ea3553;">￥{{ tbody.registration_fee }}</span>
      <el-button
          type="danger"
          style="width:100px;height:40px"
          @click="Settlement"
          :loading="loading"
      >去结算
      </el-button>
    </el-card>
    <el-dialog title="二维码支付" :visible.sync="paydialog" :width="screenWidth>768?'40%':'90%'" center
               :close-on-click-modal="false" @close="goToOrder">
      <div class="paystyle">
        <img v-if="this.formData.img" :src="this.formData.img">
      </div>
    </el-dialog>

    <!--  补考弹窗  -->
    <el-dialog title="提示" :visible.sync="showRetake" :width="screenWidth>768?'40%':'90%'" center
               :close-on-click-modal="false" :show-close="false">
      <div>
        <div style="margin-bottom: 1em">您有一条请假记录</div>
        <div>如已参加补考请联系上次报名机构进行成绩录入，成绩审核通过后再进行下一级别报名，请点击“参与补考并联系报名机构”，将返回上一页面；</div>
        <div>如本次在原报名机构进行补考，请联系机构工作人员，无需进行报名缴费，请点击“参与补考并联系报名机构”，将返回上一页面；</div>
        <div>如需放弃上次考试资格，请点击我已知悉，放弃考试资格。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseRetake">参与补考并联系报名机构</el-button>
        <el-button type="primary" @click="handleConfirmRetake">我已知悉，放弃考试资格</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {isMobile} from "@/util/validate.js";
import noData from "@/views/admin/components/noData.vue";
import makeOutInvoice from "@/views/admin/components/makeOutInvoice.vue";
import {GetUserInvoiceInfo, GetDicData, GDCloudPay, GetPaymentStatus} from "@/api/admin/common.js";
import {
  TestApplicationList,
  TestClassSettlementDetails,
  TestClassSignUp,
  CheckExistRetake
} from "@/api/admin/athletes.js";
import {ModifyTestApplication} from "@/api/admin/new.js";
import {mapGetters} from "vuex";
import {UpdateRetakeFlag} from "../../../../api/admin/athletes";

let that = this;
var checkmobile = (rule, value, callback) => {
  if (value === "无") {
    return callback();
  }
  if (value === "") {
    callback(new Error("请输入教练员手机号"));
  } else {
    if (isMobile(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的手机号"));
    }
  }
};
export default {
  components: {
    noData,
    makeOutInvoice
  },
  computed: {
    ...mapGetters(["screenWidth"])
  },
  data() {
    return {
      tbody: {},
      tbodyShow: false,
      InvoiceVisible: false,
      radio: "1",
      newId: {},
      test_class_can_apply_for_grade: [],
      imgPath: window.apiObj.apiUrl,
      formData: {},
      paydialog: false,
      formInvoice: {},
      comonInvoice: [
        {title: "发票类型：", value: "电子普通发票"},
        {title: "发票内容：", value: "商品明细"}
      ],
      loading: false,
      coachForm: {
        status: 0,
        train: '',
        coach: '',
        phone: ''
      },
      rules: {
        train: [
          {required: true, message: '请输入培训机构', trigger: 'blur'}
        ],
        coach: [
          {required: true, message: '请输入教练员姓名', trigger: 'blur'}
        ],
        phone: [
          {validator: checkmobile, trigger: 'blur'}
        ],
      },
      orderSn: '',
      payview: false,
      warnMsg: '注意事项：一旦缴费将安排测试资源，个人原因未按时参加不进行退费，可联系机构另安排时间参加，同级别下一次不另收费用，名额保留时间以测试通知为主。',
      showRetake: false,
      retakeId: ''
    };
  },
  created() {
    this.path();
    this.getList();
    this.defaultData();
    this.time = setInterval(() => {
      this.intervalPay();
    }, 10000);
  },
  beforeCreate: function () {
    that = this;
  },
  methods: {
    intervalPay() {
      if (this.payview) {
        GetPaymentStatus({order_sn: this.orderSn}).then(data => {
          if (data.data.result.orderStatus == 3) {
            this.$message({
              message: "支付完成",
              type: "success"
            });
            this.paydialog = false;
            this.payview = false;
            this.goToOrder();
          }
        });
      }
    },
    path() {
      var pathList = [
        {title: "您当前的位置"},
        {title: "首页", path: "/index"},
        {path: "/test", title: "测试报名"},
        {
          path:
              "/test/signUp?id=" +
              this.$route.query.id +
              "&key=" +
              this.$route.query.key,
          title: "报名信息"
        },
        {
          path: this.$route.fullPath,
          title: "确认订单"
        }
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    defaultData() {
      GetUserInvoiceInfo({}).then(data => {
        var list = data.data.result;
        if (list.invoiceInfo) {
          if (list.invoiceInfo.custtype == "01") {
            this.radio = "2";
            this.formInvoice = list.invoiceInfo;
          } else {
            this.radio = "1";
          }
        }
      });
      GetDicData({classCode: "test_class_can_apply_for_grade"}).then(data => {
        if (data.data.result) {
          this.test_class_can_apply_for_grade = data.data.result;
        }
      });
    },
    cancelData() {
      this.InvoiceVisible = false;
    },
    getList() {
      this.newId = this.$route.query;
      TestApplicationList({
        test_class_id: this.newId.id,
        grade: this.newId.key
      }).then(data => {
        const list = data.data.result;
        if (list) {
          if (list.items.length > 0) {
            this.tbodyShow = true;
            this.tbody = list.items[0];
            this.coachForm.train = this.tbody.mechanism_fullName;
          } else {
            this.tbodyShow = false;
          }
        }
      });
      /*TestClassSettlementDetails({test_class_id: this.newId.id}).then(
          data => {
            const list = data.data.result;
            if (list) {
              if (list.items.length > 0) {
                var temII = list.items.length - 1;
                this.tbodyShow = true;
                //this.tbody = list.items[0];
                this.tbody = list.items[temII];
                this.coachForm.train = this.tbody.mechanism_fullName;
                this.coachForm.order_sn = this.tbody.order_sn;
              } else {
                this.tbodyShow = false;
              }
            }
          }
      );*/
    },
    cancel() {
    },
    Settlement() {
      this.$refs.coachForm.validate(valid => {
        if (valid) {
          this.$confirm(this.warnMsg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false,
            closeOnPressEscape: false
          }).then(async () => {
            // 是否补考
            const res = await CheckExistRetake();
            if (res.data.result.isSuccess) {
              const retake = res.data.result.data
              if (retake) {
                this.showRetake = true
                this.retakeId = retake.applicationId
              } else {
                this.signUp();
              }
            } else {
              this.$message({
                message: '获取报名信息失败',
                type: 'warning'
              })
            }
          })
        }
      })
    },
    handleCloseRetake(){
      this.showRetake = false
      this.$router.push({
        path: "/test",
      });
    },
    handleConfirmRetake() {
      UpdateRetakeFlag(this.retakeId);
      this.signUp();
    },
    signUp() {
      this.coachForm.test_class_id = this.newId.id;
      this.coachForm.grade = this.newId.key
      this.loading = true;
      TestClassSignUp(this.coachForm).then(data => {
        const list = data.data.result;
        if (list && list.isSuccess) {
          this.orderSn = list.errorMsg
          GDCloudPay({order_sn: this.orderSn}).then(res => {
            if (res.data.result.isSuccess) {
              this.paydialog = true;
              this.payview = true;
              this.formData.img = this.imgPath + res.data.result.payCode;
            }
          });
        } else {
          this.$message({
            message: list.errorMsg,
            type: "warning"
          });
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    changeStatus(value) {
      if (value == 0) {
        this.coachForm.train = this.tbody.mechanism_fullName;
      } else {
        this.coachForm.train = '';
      }
    },
    goToOrder() {
      this.$router.push({path: "/personal/gradeTestRecord"});
    },
  },
  beforeDestroy() {
    this.$off("cancel", "default");
  },
  filters: {
    grade: data => {
      for (var i in that.test_class_can_apply_for_grade) {
        if (that.test_class_can_apply_for_grade[i].value == data) {
          return that.test_class_can_apply_for_grade[i].label;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.sureOrder {
  .thead {
    background: #f5f6f6;
    overflow: hidden;

    li {
      float: left;
      padding: 6px;
      box-sizing: border-box;
      text-align: center;
    }

    li:first-child {
      width: 50%;
    }

    li:nth-child(2) {
      width: 20%;
    }

    li:nth-child(3) {
      width: 30%;
    }
  }

  .tbody {
    .tbody_con {
      border-bottom: 1px solid #dcdfe6;

      .order {
        padding: 6px 18px;
        background: #f5f6f6;
        overflow: hidden;
        margin-top: 10px;
      }

      .invoiceDetail {
        ul {
          li {
            line-height: 30px;

            span:first-child {
              display: inline-block;
              width: 105px;
              text-align: right;
              margin-right: 10px;
            }
          }
        }
      }

      .upData {
        color: #409eff;
        cursor: pointer;
        margin-left: 30px;
      }

      .upData:hover {
        opacity: 0.5;
      }

      .order_detail {
        padding: 15px 10px;
        overflow: hidden;

        .detail_con {
          overflow: hidden;
          width: 50%;
          float: left;
          display: flex;

          ul {
            li {
              line-height: 25px;
              font-size: 15px;
              overflow: hidden;

              label {
                display: block;
                width: 90px;
                float: left;
              }

              span {
                display: block;
                float: left;
                width: 72%;
              }
            }
          }
        }

        @media screen and (max-width: 500px) {
          .detail_con {
            //flex-direction: column;
            //align-items: center;
          }
        }

        .money {
          width: 20%;
          margin: auto;
          float: left;
          text-align: center;
          padding: 27px 0;
          border-left: 1px solid rgb(196, 196, 196);
          border-right: 1px solid rgb(196, 196, 196);

          h4 {
            font-weight: normal;
          }
        }

        .detail {
          width: 15%;
          margin: auto;
          float: left;
          text-align: center;
          padding: 39px 0;
          border-right: 1px solid rgb(196, 196, 196);

          a {
            color: #000000;
          }
        }

        .operate {
          padding-top: 25px;
          line-height: 24px;

          a {
            color: #000000;
            display: block;
            text-align: center;
            margin-bottom: 2px;
          }
        }
      }
    }

    .tbody2_con {
      border-bottom: 1px solid #dcdfe6;

      .order {
        padding: 6px 18px;
        background: #f5f6f6;
        overflow: hidden;
        margin-top: 10px;
      }

      .order_detail {
        padding: 15px 10px;
        overflow: hidden;

        h4 {
          font-weight: normal;
        }

        .money {
          width: 20%;
          margin: auto;
          float: left;
          text-align: center;
          padding: 27px 0;
          border-left: 1px solid rgb(196, 196, 196);
          border-right: 1px solid rgb(196, 196, 196);

          h4 {
            font-weight: normal;
          }
        }

        .detail {
          width: 15%;
          margin: auto;
          float: left;
          text-align: center;
          padding: 39px 0;
          border-right: 1px solid rgb(196, 196, 196);

          a {
            color: #000000;
          }
        }

        .operate {
          padding-top: 25px;
          line-height: 24px;

          a {
            color: #000000;
            display: block;
            text-align: center;
            margin-bottom: 2px;
          }
        }
      }
    }

    li:last-child {
      border-bottom: none;
    }
  }

  .signUp_card {
    margin-top: 10px;
    text-align: right;

    span {
      display: inline-block;
      margin-right: 10px;
      font-size: 16px;
    }

    span + span {
      font-size: 18px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .tbody_con {
    .order {
      font-size: 14px;
    }

    .order_detail {
      .detail_con {
        img {
          display: none;
        }

        ul {
          width: 100% !important;

          li {
            label {
              width: 38% !important;
            }

            span {
              width: 62% !important;
            }
          }
        }
      }

      .money {
        font-size: 15px;
      }

      .operate {
        font-size: 15px;
      }
    }
  }

  .tbody2_con {
    .order {
      font-size: 14px;
    }

    .order_detail {
      img {
        display: none;
      }

      .money {
        font-size: 15px;
      }

      .operate {
        font-size: 15px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .sureOrder {
    .con {
      .tbody {
        .tbody_con {
          .order {
            span {
              float: none !important;
              line-height: 22px;
            }
          }

          .order_detail {
            .detail_con {
              width: 100% !important;
              border-bottom: 1px solid #f5f6f6;
              padding-bottom: 15px;
            }

            .money {
              border-left: none;
              border-right: none;
              width: 100%;
              border-bottom: 1px solid #f5f6f6;
              padding: 10px 0;
            }
          }
        }

        .tbody2_con {
          .order {
            span {
              float: none !important;
              line-height: 22px;
            }
          }

          .order_detail {
            .order_detail_con {
              width: 100% !important;
              border-bottom: 1px solid #f5f6f6;
              padding-bottom: 15px;

              h4 {
                padding-top: 0 !important;
              }
            }

            .money {
              border-left: none;
              border-right: none;
              width: 100%;
              border-bottom: 1px solid #f5f6f6;
              padding: 10px 0 !important;
              text-align: left;
            }

            .detail {
              width: 100%;
              border-right: 0;
              padding: 10px 0;
              text-align: left;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .sureOrder {
    .tbody {
      .tbody_con {
        .order_detail {
          position: relative;

          .detail_con {
            display: block;
            width: 100% !important;

            .el-image {
              width: 50% !important;
            }
          }
        }

        .money {
          position: absolute;
          left: 52%;
        }

        .operate {
          position: absolute;
          right: 0;
        }

        .el-input {
          width: 100% !important;
        }
      }
    }
  }
}
</style>
